export default "__VITE_ASSET__vfsI66V2__"